/**
 * Duplicate-name detection for a single staged upload batch.
 *
 * The server-side `check-conflicts` preflight only reports collisions against
 * documents that *already exist* in the destination — it dedupes the requested
 * paths, so it can't see two files in the same selection that target the same
 * path. Those would upload sequentially and the second would hit a 409 (the
 * first just created the row), surfacing as a per-file error rather than an
 * up-front prompt. Catch them on the client first.
 */
export function findDuplicateTargetPaths(paths: string[]): string[] {
  const seen = new Set<string>()
  const duplicated = new Set<string>()
  for (const path of paths) {
    if (seen.has(path)) {
      duplicated.add(path)
    } else {
      seen.add(path)
    }
  }
  return [...duplicated]
}
